<template>
  <div v-if="isLoading">
    <div class="portal-loader"></div>
    <div class="portal-loader__icon">
      <fa-icon :icon="['fa', 'couch']" />
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isLoading() {
      return this.$loading.isLoading()
    }
  }
}
</script>
<style lang="sass">

.portal-loader
  height: 100vh
  width: 100vw
  background: white
  opacity: 0.7
  top: 0
  left: 0
  position: fixed
  z-index: 10

.portal-loader__icon
  height: 100vh
  width: 100vw
  position: fixed
  z-index: 11
  top: 0
  left: 0
  display: flex
  justify-content: center
  align-items: center
  & > svg
    animation: spin 2s ease-in-out infinite
    font-size: 5rem
    color: $accent-color

@keyframes spin
  20%
    -webkit-transform: rotate(360deg)
    transform: rotate(360deg)
  50%
    -webkit-transform: rotate(180deg)
    transform: rotate(180deg)
  100%
    -webkit-transform: rotate(360deg)
    transform: rotate(360deg)
</style>
